import styles from './style.module.scss';
import { src } from '../../../utils/common';
import FadeIn from '/components/commonComponents/fadeIn';
import classnames from 'classnames';
import { WebPNextImage } from '../../WebPImage';

const ReasonCard = ({
  reasons,
  title = '为什么选择SteamLake',
  bgColor = '#fff',
}) => {
  return (
    <FadeIn>
      <div className={styles['resaons']} style={{ backgroundColor: bgColor }}>
        <div className={styles['reason-title']}>{title}</div>
        <div className={styles['items']}>
          {reasons.map((item, index) => (
            <div key={index} className={styles['item-wrapper']}>
              <WebPNextImage
                width={350}
                height={120}
                src={item.picUrl}
                className={styles['itemImg']}
                alt={item.title}
              />
              <div className={styles['itemTitle']}>{item.title}</div>
              <div className={styles['itemContent']}>{item.content}</div>
            </div>
          ))}
        </div>
      </div>
    </FadeIn>
  );
};

export default ReasonCard;
